@if(!isLoading){
    <div class="h-100 w-100 p-5">
        @if (data) {
            <div class="d-flex justify-content-between align-items-center">
                <h1 class="text-color-primary">{{currentMetricType.title}}</h1>
                <div>
                    <mat-form-field class="pe-auto me-2">
                        <mat-label>Select Metric Type</mat-label>
                        <mat-select [value]="currentMetricType" (selectionChange)="obtainData($event.value)">
                            @for (metricType of allMetricsTypes; track metricType.metric_uuid) {
                                <mat-option [value]="metricType">{{metricType.metric}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    @if (this.currentUnit === "time") {
                        <mat-form-field class="pe-auto">
                            <mat-label>Select Time Unit</mat-label>
                            <mat-select [value]="currentTimeUnit" (selectionChange)="onChangeTimeUnit($event)">
                                @for (value of timeValues; track value.name) {
                                <mat-option [value]="value.enum">{{value.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                </div>
                
            </div>
        }
        <p-chart
            type="bar"
            [data]="chartData"
            [options]="chartOptions"
            class="full-height-chart"
        />
    </div>
}@else{
    <div class="h-100 d-flex justify-content-center align-items-center loading">
        <mat-progress-spinner mode="indeterminate"> </mat-progress-spinner>
    </div>
}
